import { FC } from 'react';

/**
 * 상품형(교환형) 상품권 교환·사용 시 유의사항(잔액 소멸 / 사용처 사전 문의).
 * 신청 폼 · 교환신청 완료 · 발송완료 화면에서 공통으로 노출한다.
 */

// <ul> 안에 그대로 끼워 쓰는 항목들 (신청 폼의 기존 유의사항 목록에 합류)
export const ExchangeCautionItems: FC = () => (
  <>
    <li>
      •{' '}
      <span className="font-bold text-stone-500">
        재고가 없을 경우 동일 가격 이상의 상품으로 교환
      </span>
      되며, 차액은 본인 부담입니다.
    </li>
    <li>
      •{' '}
      <span className="font-bold text-stone-500">
        표시 금액보다 낮은 가격의 상품으로 교환하면 차액(잔액)이 소멸될 수 있습니다.
      </span>{' '}
      같거나 높은 가격의 상품으로 교환하시길 권장합니다.
    </li>
    <li>
      • 잔액·교환 등 운영방침은 사용처마다 다르니,{' '}
      <span className="font-bold text-stone-500">자세한 내용은 사용처에 문의</span>해
      주세요.
    </li>
  </>
);

// 완료/발송 화면용 독립 박스 (신청 폼과 동일한 유의사항 형식)
const ExchangeCautionNotice: FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`rounded-lg bg-stone-100 p-3 ${className}`}>
    <p className="text-xs font-medium text-stone-500">이용안내</p>
    <ul className="mt-1.5 space-y-1 text-xs text-stone-400">
      <ExchangeCautionItems />
    </ul>
  </div>
);

export default ExchangeCautionNotice;
